import moment from 'moment';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getDataSuccess: (data) => ({ data }),
  saveDataById: (data) => ({ data }),
  getDataById:
    (id) =>
    async ({ Api }) => {
      try {
        const response = await Api.get(`promotions/${id}`);
        if (response.status === 200) {
          dispatcher.saveDataById(response.result);
        }
      } catch (error) {
        console.log('Error: ', error);
      }
    },
  getData:
    (search, paging, promoCodeType) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().promotion.paging;
      let { result, status } = await Api.get('promotions', {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        promoCodeType,
      });
      status === 200 && dispatcher.getDataSuccess(result);
    },
  editData:
    (data, searchKey, callback, onFinish, id) =>
    async ({ Api, customToast, getState }) => {
      const { startDate, endDate, ...restparams } = data;
      const body = {
        ...restparams,
        startDate: moment(startDate).startOf('day').format(),
        endDate: moment(endDate).endOf('day').format(),
        id,
      };

      let response;
      if (id) {
        response = await Api.put(`promotions/${id}`, body);
      } else {
        response = await Api.post('promotions', body);
      }

      if (response.status === 200) {
        let { paging } = getState().userManagement;
        dispatcher.getData(searchKey, paging);
        customToast('success', 'Success');
        callback();
      }
      onFinish();
    },
  deleteData:
    (id, searchKey, filterOption = {}) =>
    async ({ Api, customToast, getState }) => {
      const response = await Api.delete(`promotions/${id}`);
      if (response.status === 200) {
        let { paging } = getState().trainerManagement;
        dispatcher.getData(searchKey, paging, filterOption);
        customToast('success', 'Success');
      }
    },
  createPromoCode:
    (payload, onSuccess, onFail) =>
    async ({ Api }) => {
      let { status } = await Api.post(`promotions`, payload);
      status === 200 ? onSuccess() : onFail();
    },
  editPromoCode:
    (id, payload, onSuccess, onFail) =>
    async ({ Api }) => {
      let { status } = await Api.put(`promotions/${id}`, payload);
      status === 200 ? onSuccess() : onFail();
    },
  deletePromoCode:
    (id, onSuccess, onFail) =>
    async ({ Api }) => {
      let { status } = await Api.delete(`promotions/${id}`);
      status === 200 ? onSuccess() : onFail();
    },
};

const dispatcher = synthesize('promotion', mapDispatchToAC);
export default dispatcher;
